import type { OperatorConfig } from '../types';

/**
 * Stage Environment Configuration
 * Development/testing environment (creator-eco-stage)
 */
export const stageConfig: OperatorConfig = {
    operatorName: 'bbs-dev',
    domainDisplayName: 'Dev Env',
    operatorSalt: 'E1F53135E559C253LA',
    domainName: '',
    rpcBaseUrl: 'https://kylin.eosusa.io',
    contractName: 'bbscommunity',
    registryContractName: 'dwebregistry',
    fiatInProviders: ['moonpay', 'EOS-Transfer'],
    backedToken: 'BBS',
    bbsTokenETH: '0xFEb03A7853a30C5AA83Aa2Df9259e08F4Cb18aC8',
    stakingContractETH: '0x22011a6889e29D541190579cc6eE2a8BB81B0EEB',
    selectedNetworkName: 'ropsten',
    contractDeploymentBlock: 0,
    stakingTokenPageRedirect: 'PIKACHU',
    moonpayWidgetBaseUrl: 'https://buy-staging.moonpay.io',
    moonpayApiKey: 'pk_test_GsvlB30codIxsnNnTzkVfTw1dFSpY6ID',
    transakApiKey: 'c4427519-00ca-4482-b82c-fe0d7ad322b0',
    transakWidgetBaseUrl: 'https://staging-global.transak.com',
    appCheckRecaptchaKey: '6Lcsro0dAAAAAO6K12pqUd5D4AiPkd0fDiZY-VYZ',
    frontendFunctionsBaseUrl: 'https://mainwebpagev2-cffkzhmwta-uc.a.run.app/api',
    functionsBaseUrl: 'https://us-central1-creator-eco-stage.cloudfunctions.net',
    cloudRunBaseUrl: 'https://bbs-cloudrun-299158536336.us-central1.run.app/bbs-api',
    firebaseConfig: {
        apiKey: 'AIzaSyD1T5c6FNVGf3oyDSK5TGJttBPj_HJcjfc',
        authDomain: 'creator-eco-stage.web.app',
        databaseURL: 'https://creator-eco-stage.firebaseio.com',
        projectId: 'creator-eco-stage',
        storageBucket: 'creator-eco-stage.appspot.com',
        messagingSenderId: '299158536336',
        appId: '1:299158536336:web:3b2b13f7d52f298e305815',
    },
    upvote: {
        contractName: 'stagedeboard',
    },
    mobileApp: {
        apn: 'io.deweb.messageboard.stg',
        dynamicLink: 'https://bbsnetworkstage.page.link',
        announcementUrl: 'https://deweb.app/PIKACHU/posts/kglaYv5rzFyT5HpmnpzG',
        isi: '1642160186',
        ibi: 'io.deweb.messageboard',
    },
    googleProviderClientId: '299158536336-bq7qtjsk954pia4blpdpk9belfscob27.apps.googleusercontent.com',
    cdn: {
        storageBaseUrl: 'https://creator-eco-stage.b-cdn.net',
    },
};
